import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";

export interface AccountState {
  rootAccounts: any[];
  selectedSite: any | null;
  selectedAccount: any | null;
  activeAppId: string | null;
  hideCaseNestTermsBanner: boolean;
  sites: Record<string, any>;
  appSiteIds: Record<string, any>;
}

const initialState: AccountState = {
  rootAccounts: [],
  selectedSite: null,
  selectedAccount: null,
  activeAppId: null,
  hideCaseNestTermsBanner: false,
  sites: {},
  appSiteIds: {},
};

const accountSlice = createSlice({
  name: "account",
  initialState,
  reducers: {
    setRootAccounts: (state, action: PayloadAction<any[]>) => {
      state.rootAccounts = action.payload;
    },
    selectSite: (state, action: PayloadAction<any>) => {
      state.selectedSite = action.payload;
    },
    selectAccount: (state, action: PayloadAction<any>) => {
      state.selectedAccount = action.payload;
      state.selectedSite = null;
    },
    setActiveAppId: (state, action: PayloadAction<any>) => {
      state.activeAppId = action.payload;
    },
    hideCaseNestTermsBanner: (state) => {
      state.hideCaseNestTermsBanner = true;
    },
    // Keep the per-site shallow copy the classic reducer made, so we never
    // store (and Immer-freeze) the caller's payload site objects by reference.
    setSites: (state, action: PayloadAction<{ sites: any[]; appId: string }>) => {
      const appSiteIds: string[] = [];
      for (const site of action.payload.sites) {
        state.sites[site.externalId] = { ...site };
        appSiteIds.push(site.externalId);
      }
      state.appSiteIds[action.payload.appId] = appSiteIds;
    },
  },
});

export const {
  setRootAccounts,
  selectSite,
  selectAccount,
  setActiveAppId,
  hideCaseNestTermsBanner,
  setSites,
} = accountSlice.actions;

export default accountSlice.reducer;
